import { typeAppointmentSchema } from "../HomeApi";
import { AvailabilitySlot } from "./generateStartTimes";
import momentTz from "moment-timezone";

export function removeClashingTimeSlots(
  timeSlots: AvailabilitySlot[],
  appointments: typeAppointmentSchema[]
): AvailabilitySlot[] {
  const availableTimeSlots: AvailabilitySlot[] = [];

  timeSlots.forEach((timeSlot) => {
    let isClashing = false;

    appointments.forEach((appointment) => {
      const timeslotStartTime = momentTz(timeSlot.startTime).tz(
        "Asia/Singapore"
      );
      const timeslotEndTime = momentTz(timeSlot.endTime).tz("Asia/Singapore");
      const appointmentStartTime = momentTz(appointment.startTime).tz(
        "Asia/Singapore"
      );
      const appointmentEndTime = momentTz(appointment.endTime).tz(
        "Asia/Singapore"
      );

      if (
        timeSlot.calendarUuid === appointment.calendar.uuid &&
        ((timeslotStartTime.isSameOrAfter(appointmentStartTime) &&
          timeslotStartTime.isBefore(appointmentEndTime)) ||
          (timeslotEndTime.isAfter(appointmentStartTime) &&
            timeslotEndTime.isSameOrBefore(appointmentEndTime)))
      ) {
        isClashing = true;
      }
    });
    if (!isClashing) {
      availableTimeSlots.push(timeSlot);
    }
  });

  return availableTimeSlots;
}
